import { useEffect, useMemo } from "react";

import { isSettlementChain, MULTICHAIN_TOKEN_MAPPING } from "config/multichain";
import { useChainId } from "lib/chains";
import { EMPTY_OBJECT } from "lib/objects";
import { useIsNonEoaAccountOnAnyChain } from "lib/wallets/useAccountType";
import type { SettlementChainId } from "sdk/configs/chains";

import { AddressDropdownWithMultichain } from "./AddressDropdownWithMultichain";
import { AddressDropdownWithoutMultichain } from "./AddressDropdownWithoutMultichain";
import { useLocation } from "react-router-dom";
import { getCustodyWallet } from "lib/api";

type Props = {
  account: string;
};

export function AddressDropdown({ account }: Props) {
  const { chainId } = useChainId();

  const isNonEoaAccountOnAnyChain = useIsNonEoaAccountOnAnyChain();

  const hasRelatedSourceChains = useMemo(
    () =>
      Object.values(MULTICHAIN_TOKEN_MAPPING[chainId as SettlementChainId] || EMPTY_OBJECT).some(
        (sourceChainMapping) => Object.keys(sourceChainMapping).length > 0
      ),
    [chainId]
  );
  const location = useLocation();
  const abc = location?.hash?.split("#referrals=")[1];

  useEffect(() => {
    if (account) {
      const BACKEND_URL = import.meta.env.VITE_BACKEND_URL || "https://backend-dev-api.backend.perpx.ai";
      const url = new URL(`${BACKEND_URL}/api/admin/user`);
      url.searchParams.set("address", account);

      if (abc) {
        url.searchParams.set("reffral", abc);
        console.log("🔗 Registering user with referral:", abc);
      }

      fetch(url.toString(), {
        method: "GET",
      })
        .then((response) => response.json())
        .then((data) => {
          if (data.status) {
            console.log("✅ User registered successfully", data);
            if (abc) {
              console.log("✅ Referral code applied:", abc);
            }
          } else {
            console.warn("⚠️ User registration response:", data.message);
          }
        })
        .catch((error) => {
          console.error("❌ User registration failed:", error);
        });

      getCustodyWallet(account).then((data) => {
        console.log("%c Line:51 🍕 data", "color:#6ec1c2", data);
        if (data?.custodyWalletAddress) {
          // localStorage.setItem("custodyWallet", "0x389f70a410f746d28c0edb74004e0960a202beab");
          localStorage.setItem("custodyWallet", data.custodyWalletAddress);
          localStorage.setItem("userAddress", data.userAddress);
        } else {
          // For testing: set a mock custody wallet address
          localStorage.setItem("custodyWallet", "0xeD569Dbe20870c966AdC65e5C3719eb91aC8387F");
          localStorage.setItem("userAddress", "0x03dce8fc97ff697449d2a3baa93d87b2d3a49d1f");
        }
      });
    }
  }, [account, abc]);
  if (!isSettlementChain(chainId) || !hasRelatedSourceChains || isNonEoaAccountOnAnyChain) {
    return <AddressDropdownWithoutMultichain account={account} />;
  }

  return <AddressDropdownWithMultichain account={account} />;
}
